import { render } from "./PreviewImage.vue?vue&type=template&id=ba7e4e5c&scoped=true"
import script from "./PreviewImage.vue?vue&type=script&lang=js"
export * from "./PreviewImage.vue?vue&type=script&lang=js"

import "../style.scss?vue&type=style&index=0&id=ba7e4e5c&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba7e4e5c"]])

export default __exports__